import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import CloseIcon from "../../../assets/SVG/closeIcon";
import FlagIcon from "../../../assets/SVG/flagIcon";
import AddDrugInAreaPop from "./addDrugInAreaPop";

export default function SelectionsTableDrug({ selection, equipment,notGroup }) {
  const [open, setOpen] = useState(false);
  const [dataDrugSelect, setDataDrugSelect] = useState([]);
  useEffect(() => {
    if (selection) {
      if (equipment) {
        setDataDrugSelect(
          selection?.map((x) => {
            return { equipmentId: x?.data?.id };
          })
        );
      } else {
        setDataDrugSelect(
          selection?.map((x) => {
            return { drugId: x?.data?.id };
          })
        );
      }
    }
  }, [selection]);
  // console.log(dataDrugSelect);
  // console.log(selection);
  return (
    <>
      <AddDrugInAreaPop
        setDataDrugSelect={setDataDrugSelect}
        dataDrugSelect={dataDrugSelect}
        open={open}
        setOpen={setOpen}
        equipment={equipment}
        notGroup={notGroup}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{ boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)" }}
          bgcolor="#9091A6"
          width="65%"
          height="60px"
          borderRadius="30px"
          position={"fixed"}
          bottom="20px"
          display="flex"
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Box display="flex" alignItems="center" mr="20px" gap="20px">
            <CloseIcon size="1.8" color="white" />
            <Typography
              fontFamily={"Shabnam"}
              color="white"
              fontSize="18px"
            >{`${selection?.length} مورد انتخاب شده`}</Typography>
          </Box>
          <Box display="flex">
            <Box
              bgcolor="#686A97"
              width="150px"
              height="40px"
              borderRadius="10px"
              display="flex"
              alignItems={"center"}
              justifyContent={"center"}
              color="white"
              marginInlineEnd={"20px"}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <FlagIcon color="white" />
              {"افزودن به اردو"}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
